import { getAnexos as dadosAnexos, criarAnexos, deletarAnexo } from '@/resources/ofertasCompra';

const ANEXOS = 'ANEXOS';
const ANEXOS_ADICIONAR = 'ANEXOS_ADICIONAR';
const ANEXOS_LIMPAR = 'ANEXOS_LIMPAR';
const ANEXOS_ATUALIZAR_PROGRESSO_UPLOAD = 'ANEXOS_ATUALIZAR_PROGRESSO_UPLOAD';
const ANEXOS_ZERAR_PROGRESSO_UPLOAD = 'ANEXOS_ZERAR_PROGRESSO_UPLOAD';
const ANEXO_REMOVER = 'ANEXO_REMOVER';

const extractAnexosFromResponse = response => {
  const payload = response?.data;

  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;

  return null;
};

const extractAnexoFromCreateResponse = response => {
  const payload = response?.data;

  if (payload?.data && !Array.isArray(payload.data)) return payload.data;
  if (payload && !Array.isArray(payload) && payload.id != null) return payload;

  return null;
};

const normalizeAnexo = anexo => ({
  ...anexo,
  pncpUrl: anexo?.pncpUrl || anexo?.urlPncp || null,
});

const mutations = {
  [ANEXOS](state, data) {
    if (data && Array.isArray(data)) {
      state.anexos = data.map(normalizeAnexo);
    }
  },
  [ANEXOS_ADICIONAR](state, data) {
    const anexo = normalizeAnexo(data);

    if (anexo.tipo === 'EDITAL') {
      const indice = state.anexos.findIndex(item => item.tipo === 'EDITAL');
      if (indice > -1) {
        state.anexos.splice(indice, 1, anexo);
      } else {
        state.anexos = [...state.anexos, anexo];
      }
    } else {
      state.anexos = [...state.anexos, anexo];
    }
  },
  [ANEXO_REMOVER](state, id) {
    const index = state.anexos.findIndex(anexo => anexo.id === id);
    if (index > -1) {
      state.anexos.splice(index, 1);
    }
  },
  [ANEXOS_LIMPAR](state) {
    state.anexos = [];
  },
  [ANEXOS_ATUALIZAR_PROGRESSO_UPLOAD](state, progresso) {
    state.anexosUpload = Math.round((progresso.loaded / progresso.total) * 100);
  },
  [ANEXOS_ZERAR_PROGRESSO_UPLOAD](state) {
    state.anexosUpload = 0;
  },
};

const actions = {
  async buscarOfertaCompraAnexos({ commit }, ofertaCompraId) {
    const response = await dadosAnexos(ofertaCompraId);
    if (response.status !== 200) return Promise.reject(response);

    const anexos = extractAnexosFromResponse(response);
    if (!anexos) return Promise.reject(response);

    return commit(ANEXOS, anexos);
  },
  async adicionarOfertaCompraAnexos({ commit, rootState }, dados) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const response = await criarAnexos(ofertaCompraId, dados, {
      onUploadProgress: progress => commit(ANEXOS_ATUALIZAR_PROGRESSO_UPLOAD, progress),
    });
    if (response.status !== 201) return Promise.reject(response);

    const anexo = extractAnexoFromCreateResponse(response);
    if (!anexo) return Promise.reject(response);

    return commit(ANEXOS_ADICIONAR, anexo);
  },
  validarOfertaCompraAnexos({ state }) {
    return state.anexos.length && state.anexos.some(anexo => anexo.tipo === 'EDITAL');
  },
  limparAnexosPregao({ commit }) {
    commit(ANEXOS_LIMPAR);
  },
  async removerOfertaCompraAnexo({ commit, rootState }, id) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const anexo = await deletarAnexo(ofertaCompraId, id);
    if (anexo.status === 204) commit(ANEXO_REMOVER, id);
  },
  zerarAnexosUploadOfertaCompra({ commit }) {
    commit(ANEXOS_ZERAR_PROGRESSO_UPLOAD);
  },
};

const getters = {
  obterOfertaCompraAnexos(state) {
    return state.anexos;
  },
  obterAnexosUploadOfertaCompra(state) {
    return state.anexosUpload;
  },
};

const state = {
  anexos: [],
  anexosUpload: 0,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
